import React from "react";
import { ServiceHeader, ServiceImageSlider } from "../../SecondComponents";
import serviceImg from '../../secondAssets/Images/serviceSection.png'
import serviceTeethImg from '../../secondAssets/Images/serviceTeethImg.png'
import service2Img from '../../secondAssets/Images/serviceImg.png'
import { dentistryData, serviceData } from "../../secondUtils/constants";
import { MdKeyboardArrowRight } from "react-icons/md";


const SecondService = (props) => {
    const { selectedLanguage, language } = props
    const isELSelect = language?.language === 'english'
    const isAlSelect = language?.language === 'arabic'
    return (
        <div className="main">
            <div className="second-design-service-container">
                <div className="service-top-div">
                    <div>
                        <h1>{selectedLanguage?.txt_services}</h1>
                    </div>
                </div>
                <ServiceHeader serviceHeaderImg={serviceImg} serviceHeading={selectedLanguage?.txt_dental_outreach_programs} serviceText={selectedLanguage?.txt_opd_dental_checkup} />
                <div className="service-cards-main">
                    {
                        serviceData?.map((v, i) => {
                            return (
                                <div data-aos="fade-up"
                                    data-aos-easing="ease-out-bounce"
                                    data-aos-delay="300"
                                    data-aos-duration="2000">
                                    <img src={v?.imageUrl} alt="" />
                                    <h2>
                                        {isELSelect ? v?.heading : (isAlSelect ? v?.alHeading : v?.glHeading)}
                                    </h2>
                                    <p>
                                        {isELSelect ? v?.text : (isAlSelect ? v?.alText : v?.glText)}
                                    </p>
                                </div>
                            )
                        })
                    }
                </div>
                <ServiceHeader className='service-painless-header' serviceHeaderImg={service2Img} serviceHeading={selectedLanguage?.txt_painless_dentistry_is_our_goal} serviceText={selectedLanguage?.txt_dental_hygiene_for_all_is_our_motto} />
                <div className="dentistry-container"
                    data-aos="fade-up"
                    data-aos-easing="ease-out-bounce"
                    data-aos-delay="300"
                    data-aos-duration="2000">
                    {
                        dentistryData?.map((v, i) => {
                            return (
                                <div>
                                    <div className="dentistry-icon-and-heading-div">
                                        <button className="dentistry-icons">{v?.icon}</button>
                                        <div className="button-bottom-line"></div>
                                    </div>
                                    <div className="dentistry-text-div">
                                        <h2 className="dentistry-heading">
                                            {isELSelect ? v?.name : (isAlSelect ? v?.alName : v?.glName)}
                                        </h2>
                                        <p><MdKeyboardArrowRight />
                                            {isELSelect ? v?.text1 : (isAlSelect ? v?.alText1 : v?.glText1)}
                                        </p>
                                        <p><MdKeyboardArrowRight />
                                            {isELSelect ? v?.text2 : (isAlSelect ? v?.alText2 : v?.glText2)}
                                        </p>
                                        <p><MdKeyboardArrowRight />
                                            {isELSelect ? v?.text3 : (isAlSelect ? v?.alText3 : v?.glText3)}
                                        </p>
                                        <p><MdKeyboardArrowRight />
                                            {isELSelect ? v?.text4 : (isAlSelect ? v?.alText4 : v?.glText4)}
                                        </p>
                                    </div>
                                </div>
                            )
                        })
                    }
                </div>
                <div className="service-bg-section">
                    <div className="service-bg-section-overlap-div">
                        <div className="service-bg-section-div">
                            <div
                                data-aos="fade-right"
                                data-aos-easing="ease-out-bounce"
                                data-aos-delay="300"
                                data-aos-duration="2000">
                                <h1>{selectedLanguage?.txt_be_gentle_with_the_strongest}</h1>
                                <p>{selectedLanguage?.txt_the_outer_part_of_teeth}</p>
                                <button>{selectedLanguage?.read_more_button}</button>
                            </div>
                            <div
                                data-aos="fade-left"
                                data-aos-easing="ease-out-bounce"
                                data-aos-delay="300"
                                data-aos-duration="2000" className="service-bg-section-teeth-img-div">
                                <img src={serviceTeethImg} alt="serviceTeethImg" />
                            </div>
                        </div>
                    </div>
                </div>
                <div>
                    <ServiceImageSlider />
                </div>
            </div>
        </div>
    )
}

export default SecondService

